@if (loading) {
  <div class="table-responsive main-table">
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th><div class="placeholder w-100"></div></th>
          @for (field of fields; track field) {
            <th scope="col" class="sortable">
              <div class="placeholder w-100"></div>
            </th>
          }
        </tr>
      </thead>
      @for (number of [].constructor(7); track $index) {
        <tbody>
          <tr>
            <td><div class="placeholder w-100"></div></td>
            @for (field of fields; track field) {
              <td scope="col" class="sortable">
                <div class="placeholder w-100"></div>
              </td>
            }
          </tr>
        </tbody>
      }
    </table>
  </div>
}

@if (!loading && enquiry) {
  <div class="row mb-4">
    <div class="col-md">
      <dl>
        @if (enquiry.refContractTitle) {
          <dt [innerText]="'ENQUIRIES.ENQUIRY_CONTRACT_REF' | translate"></dt>
          <dd>
            <strong
              [innerText]="getDisplayedEnquiryRefTitle(enquiry, 'refContract')"
            ></strong>
          </dd>
        }
        <dt [innerText]="'ENQUIRIES.ENQUIRY_REF' | translate"></dt>
        <dd [innerText]="getDisplayedEnquiryRefTitle(enquiry, 'refEnquiry')"></dd>
      </dl>
    </div>
    <div class="col-md">
      <dl>
        <dt [innerText]="'ENQUIRIES.ENQUIRY_TYPE' | translate"></dt>
        <dd>
          <span
            class="badge text-dark"
            [class.enquiry-business]="enquiry.type === EnumEnquiryType.business"
            [class.enquiry-commercial]="enquiry.type === EnumEnquiryType.commercial"
            [class.enquiry-cargo]="enquiry.type === EnumEnquiryType.cargo"
            [class.enquiry-sport]="enquiry.type === EnumEnquiryType.sport"
            [class.enquiry-helico]="enquiry.type === EnumEnquiryType.helico"
            [class.enquiry-acmi]="enquiry.type === EnumEnquiryType.acmi"
            [innerText]="getEnumEnquiryTypeLabel(enquiry.type) | translate"
          ></span>
        </dd>
        <dt [innerText]="'ENQUIRIES.STATUS' | translate"></dt>
        <dd>
          <div class="dropdown">
            <button
                        class="btn btn-{{
                            getEnquiryStatusColor(enquiry.status)
                        }} btn-sm dropdown-toggle"
              type="button"
              id="dropdownMenuButton-status"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
                        [class.disabled]="
                            !hasAclAccess(EnumAcl.enquiriesSwitchStatus) ||
                            (enquiry.status === EnumEnquiryStatus.confirmed &&
                                !hasAclAccess(EnumAcl.enquiriesSwitchStatusFromConfirmed))
                        "
              >
              {{ getEnumEnquiryStatusLabel(enquiry.status) | translate }}
            </button>
            <div
              class="dropdown-menu dropdown-menu-end"
              aria-labelledby="dropdownMenuButton-status"
              >
              @for (enquiryStatus of getEnquiryStatus(); track enquiryStatus) {
                <button
                  type="button"
                  class="dropdown-item"
                            [innerText]="
                                'ENQUIRIES.CHANGE_STATUS_TO_X'
                                    | translate
                                        : {
                                              newStatus:
                                                  getEnumEnquiryStatusLabel(enquiryStatus)
                                                  | translate
                                          }
                            "
                (click)="changeStatus(enquiryStatus)"
                [class.disabled]="enquiry.status === enquiryStatus"
              ></button>
            }
          </div>
        </div>
      </dd>
    </dl>
  </div>
  <div class="col-md">
    <dl>
      <dt [innerText]="'ENQUIRIES.CLIENT_COMPANY' | translate"></dt>
      <dd>
        <a
          [routerLink]="'/admin/clients/' + enquiry.clientId"
          [innerHtml]="client ? client.name : enquiry.clientTitle"
        ></a>
      </dd>
      <dt [innerText]="'ENQUIRIES.CLIENT_CONTACT' | translate"></dt>
      <dd>
        <a
          [href]="'https://artheauaviation2.pipedrive.com/person/' + enquiry.contactId"
          target="_blank"
          [innerHtml]="contact ? contact.name : enquiry.contactTitle"
        ></a>
      </dd>
    </dl>
  </div>
  @if (isLogged) {
    <div class="col-md">
      <dl>
        <dt [innerText]="'ENQUIRIES.PROCESSED_BY' | translate"></dt>
        <dd class="placeholder-glow">
          @if (!processedByUser) {
            <div class="placeholder w-100"></div>
          }
          @if (processedByUser) {
            <span
                    [innerText]="
                        getUserFullname(processedByUser) + ' (' + processedByUser.initials + ')'
                    "
            ></span>
          }
        </dd>
        <dt [innerText]="'PIPEDRIVE.TITLE' | translate"></dt>
        <dd>
          @if (enquiry.pipedriveDealId) {
            <a
                    [href]="
                        'https://artheauaviation2.pipedrive.com/deal/' + enquiry.pipedriveDealId
                    "
              target="_blank"
              >
              {{ "PIPEDRIVE.OPEN_DEAL" | translate }}
              <fa-icon [icon]="faExternalLink"></fa-icon>
            </a>
          }
          @if (!enquiry.pipedriveDealId) {
            <button
              type="button"
              (click)="createDealInPipedrive()"
              class="btn btn-primary btn-sm"
              [disabled]="creatingPipedriveDeal"
                    [innerText]="
                        (creatingPipedriveDeal
                            ? 'GENERAL.CREATING'
                            : 'PIPEDRIVE.CREATE_DEAL_IN_PIPEDRIVE_FOR_ENQUIRY'
                        ) | translate
                    "
            ></button>
          }
        </dd>
      </dl>
    </div>
  }
  @if (isLogged) {
    <div class="col-md">
      <div class="d-flex align-items-start justify-content-md-end gap-2 mb-4">
        @if (
          (enquiry.status !== EnumEnquiryStatus.confirmed &&
          hasAclAccess(EnumAcl.enquiriesEdit)) ||
          (enquiry.status === EnumEnquiryStatus.confirmed &&
          hasAclAccess(EnumAcl.enquiriesEditForConfirmedEnquiry))
          ) {
          <a
            [routerLink]="'/admin/enquiries/' + enquiryId + '/edit'"
            class="btn btn-primary btn-sm"
            >
            <fa-icon [icon]="faEdit"></fa-icon>
            {{ "GENERAL.EDIT" | translate }}
          </a>
        }
        @if (hasAclAccess(EnumAcl.enquiriesDelete)) {
          <button
            type="button"
            (click)="delete()"
            class="btn btn-danger btn-sm"
            >
            <fa-icon [icon]="faTrash"></fa-icon>
            {{ "GENERAL.DELETE" | translate }}
          </button>
        }
      </div>
    </div>
  }
</div>
}

@if (!loading && enquiry) {
  @if (enquiry.status === EnumEnquiryStatus.cancelled && enquiry.reasonCancelled) {
    <div
      class="row justify-content-center"
      >
      <div class="col-md-6 col-lg-4">
        <div class="alert alert-warning">
          <dl>
            <dt [innerText]="'ENQUIRIES.REASON_CANCELLED' | translate"></dt>
            <dd
                        [innerText]="
                            getEnumEnquiryCancelledReasonLabel(enquiry.reasonCancelled.reason)
                                | translate
                        "
            ></dd>
          </dl>
          <dl>
            <dt [innerText]="'ENQUIRIES.CANCEL_COMMENT' | translate"></dt>
            <dd
              [innerText]="enquiry.reasonCancelled.comment || 'GENERAL.EMPTY' | translate"
            ></dd>
          </dl>
          <div class="text-center">
            <button
              type="button"
              class="btn btn-warning btn-sm"
              (click)="showCancellationModal()"
              >
              <fa-icon [icon]="faEdit"></fa-icon> {{ "GENERAL.EDIT" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  }
  @if (enquiry.isCompleted) {
    <div class="row justify-content-center">
      <div class="col-md-6 col-lg-4">
        <div class="alert alert-success text-center">
          {{
          "ENQUIRIES.ENQUIRY_CLOSED_ON"
          | translate
          : {
          date: enquiry.dateCompleted | date : "dd/MM/yyyy HH:mm"
        }
        }}
        @if (hasAclAccess(EnumAcl.enquiriesSetCommission)) {
          <div class="mt-2">
            <button
              type="button"
              class="btn btn-primary btn-sm"
              (click)="reopenEnquiry()"
              [innerText]="'ENQUIRIES.REOPEN' | translate"
            ></button>
          </div>
        }
      </div>
    </div>
  </div>
}
<ul class="nav nav-tabs justify-content-center" id="myTab" role="tablist">
  @if (
    enquiry.status === EnumEnquiryStatus.confirmed ||
    (enquiry.status === EnumEnquiryStatus.cancelled && invoices.length)
    ) {
    <li
      class="nav-item"
      role="presentation"
      >
      <button
        class="nav-link active"
                [attr.aria-selected]="
                    enquiry.status === EnumEnquiryStatus.confirmed ||
                    (enquiry.status === EnumEnquiryStatus.cancelled && invoices.length)
                        ? 'true'
                        : 'false'
                "
        id="flights-tab"
        data-bs-toggle="tab"
        data-bs-target="#flights-tab-pane"
        type="button"
        role="tab"
        aria-controls="flights-tab-pane"
        [innerText]="'FLIGHTS.PLURAL' | translate"
      ></button>
    </li>
  }
  <li class="nav-item" role="presentation">
    <button
      class="nav-link"
                [class.active]="
                    !(
                        enquiry.status === EnumEnquiryStatus.confirmed ||
                        (enquiry.status === EnumEnquiryStatus.cancelled && invoices.length)
                    )
                "
                [attr.aria-selected]="
                    !(
                        enquiry.status === EnumEnquiryStatus.confirmed ||
                        (enquiry.status === EnumEnquiryStatus.cancelled && invoices.length)
                    )
                        ? 'true'
                        : 'false'
                "
      id="cotations-tab"
      data-bs-toggle="tab"
      data-bs-target="#cotations-tab-pane"
      type="button"
      role="tab"
      aria-controls="cotations-tab-pane"
      [innerText]="'ENQUIRIES.AIRLINES_QUOTING.TITLE' | translate"
    ></button>
  </li>
  @if (hasAclAccess(EnumAcl.quotationsList)) {
    <li class="nav-item" role="presentation">
      <button
        class="nav-link placeholder-glow"
        id="quotations-tab"
        data-bs-toggle="tab"
        data-bs-target="#quotations-tab-pane"
        type="button"
        role="tab"
        aria-controls="quotations-tab-pane"
        aria-selected="false"
        >
        {{ "QUOTATION.PLURAL" | translate }}
        @if (loadingQuotations) {
          <span class="badge placeholder"></span>
        }
        @if (!loadingQuotations) {
          <span
            class="badge"
            [class.text-bg-secondary]="!quotations.length"
            [class.text-bg-success]="quotations.length"
            [innerText]="quotations.length"
          ></span>
        }
      </button>
    </li>
  }
  @if (hasAclAccess(EnumAcl.invoicesList)) {
    <li class="nav-item" role="presentation">
      <button
        class="nav-link placeholder-glow"
        id="invoices-tab"
        data-bs-toggle="tab"
        data-bs-target="#invoices-tab-pane"
        type="button"
        role="tab"
        aria-controls="invoices-tab-pane"
        aria-selected="false"
        >
        {{ "INVOICE.PLURAL" | translate }}
        @if (loadingInvoices) {
          <span class="badge placeholder"></span>
        }
        @if (!loadingInvoices) {
          <span
            class="badge"
            [class.text-bg-secondary]="!invoices.length"
            [class.text-bg-success]="invoices.length"
            [innerText]="invoices.length"
          ></span>
        }
      </button>
    </li>
  }
  @if (hasAclAccess(EnumAcl.flightBriefsList)) {
    <li class="nav-item" role="presentation">
      <button
        class="nav-link placeholder-glow"
        id="flight-briefs-tab"
        data-bs-toggle="tab"
        data-bs-target="#flight-briefs-tab-pane"
        type="button"
        role="tab"
        aria-controls="flight-briefs-tab-pane"
        aria-selected="false"
        >
        {{ "FLIGHT_BRIEF.PLURAL" | translate }}
        @if (loadingFlightBriefs) {
          <span class="badge placeholder"></span>
        }
        @if (!loadingFlightBriefs) {
          <span
            class="badge"
            [class.text-bg-secondary]="!flightBriefs.length"
            [class.text-bg-success]="flightBriefs.length"
            [innerText]="flightBriefs.length"
          ></span>
        }
      </button>
    </li>
  }
  @if (hasAclAccess(EnumAcl.enquiriesViewDocumentsTab)) {
    <li
      class="nav-item"
      role="presentation"
      >
      <button
        class="nav-link placeholder-glow"
        id="documents-tab"
        data-bs-toggle="tab"
        data-bs-target="#documents-tab-pane"
        type="button"
        role="tab"
        aria-controls="documents-tab-pane"
        aria-selected="false"
        >
        {{ "ENQUIRIES.DOCUMENTS.TAB" | translate }}
        @if (loadingEnquiryDocuments) {
          <span class="badge placeholder"></span>
        }
        @if (!loadingEnquiryDocuments) {
          <span
            class="badge"
            [class.text-bg-secondary]="!enquiryDocuments.length"
            [class.text-bg-success]="enquiryDocuments.length"
            [innerText]="enquiryDocuments.length"
          ></span>
        }
      </button>
    </li>
  }
</ul>
<div class="tab-content" id="myTabContent">
  @if (
    enquiry.status === EnumEnquiryStatus.confirmed ||
    (enquiry.status === EnumEnquiryStatus.cancelled && invoices.length)
    ) {
    <div
      class="tab-pane fade show active"
      id="flights-tab-pane"
      role="tabpanel"
      aria-labelledby="flights-tab"
      tabindex="0"
      >
      <app-enquiry-flights-cards
        [loading]="loadingEnquiryFlights"
        [enquiryFlights]="enquiryFlights"
        [enquiry]="enquiry"
      ></app-enquiry-flights-cards>
    </div>
  }
  <div
    class="tab-pane fade"
    id="cotations-tab-pane"
    role="tabpanel"
    aria-labelledby="cotations-tab"
    tabindex="0"
            [class.show]="
                !(
                    enquiry.status === EnumEnquiryStatus.confirmed ||
                    (enquiry.status === EnumEnquiryStatus.cancelled && invoices.length)
                )
            "
            [class.active]="
                !(
                    enquiry.status === EnumEnquiryStatus.confirmed ||
                    (enquiry.status === EnumEnquiryStatus.cancelled && invoices.length)
                )
            "
    >
    <app-enquiry-cotations [enquiry]="enquiry"></app-enquiry-cotations>
  </div>
  <div
    class="tab-pane fade"
    id="quotations-tab-pane"
    role="tabpanel"
    aria-labelledby="quotations-tab"
    tabindex="0"
    >
    <app-quotations-list-for-enquiry
      [enquiryId]="enquiryId"
    ></app-quotations-list-for-enquiry>
  </div>
  <div
    class="tab-pane fade"
    id="invoices-tab-pane"
    role="tabpanel"
    aria-labelledby="invoices-tab"
    tabindex="0"
    >
    <app-invoices-list-for-enquiry [enquiryId]="enquiryId"></app-invoices-list-for-enquiry>
  </div>
  <div
    class="tab-pane fade"
    id="flight-briefs-tab-pane"
    role="tabpanel"
    aria-labelledby="flight-briefs-tab"
    tabindex="0"
    >
    <app-flight-briefs-list-for-enquiry
      [enquiryId]="enquiryId"
    ></app-flight-briefs-list-for-enquiry>
  </div>
  @if (hasAclAccess(EnumAcl.enquiriesViewDocumentsTab)) {
    <div
      class="tab-pane fade"
      id="documents-tab-pane"
      role="tabpanel"
      aria-labelledby="documents-tab"
      tabindex="0"
      >
      <div class="card">
        @if (hasAclAccess(EnumAcl.enquiriesAddDocument)) {
        <div class="card-header text-end">
          <button type="button" class="btn btn-primary btn-sm" (click)="openAddEnquiryDocumentModal()">
            <fa-icon [icon]="faPlus" class="me-2"></fa-icon>{{ translateLabel('GENERAL.ADD') }}
          </button>
        </div>

        <div class="modal fade" tabindex="-1" role="dialog" #enquiryDocumentModal
          aria-labelledby="enquiry-document-modal-title" data-bs-backdrop="static" data-bs-keyboard="false">
          <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="enquiry-document-modal-title"
                  [innerText]="translateLabel('CLIENT_DOCUMENTS.ADD_DOCUMENT')"></h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"
                  [disabled]="addingEnquiryDocument" [attr.aria-label]="translateLabel('GENERAL.CLOSE')"></button>
              </div>
              <div class="modal-body">
                <div class="mb-3">
                  <app-file-input #enquiryDocumentFileInput labelKey="GENERAL.FILE_INPUT.DOCUMENT"
                    [busy]="addingEnquiryDocument"
                    (fileSelected)="changeEnquiryDocumentInputFile($event)"></app-file-input>
                </div>
                <div>
                  <label class="form-label" for="enquiry-document-name"
                    [innerText]="translateLabel('GENERAL.NAME')"></label>
                  <input id="enquiry-document-name" type="text" class="form-control"
                    [(ngModel)]="enquiryDocumentName" [ngModelOptions]="{ standalone: true }"
                    [disabled]="addingEnquiryDocument" />
                </div>
                @if (addingEnquiryDocument) {
                  <p class="text-muted mt-3 mb-0" role="status"
                    [innerText]="translateLabel('CLIENT_DOCUMENTS.UPLOADING')"></p>
                }
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                  [disabled]="addingEnquiryDocument" [innerText]="translateLabel('GENERAL.CANCEL')"></button>
                <button type="button" class="btn btn-primary" (click)="addEnquiryDocument()"
                  [disabled]="!enquiryDocumentFile || addingEnquiryDocument"
                  [innerText]="translateLabel(addingEnquiryDocument ? 'GENERAL.SAVING' : 'GENERAL.ADD')"></button>
              </div>
            </div>
          </div>
        </div>
        }
        <ul class="list-group list-group-flush">
          @if (!enquiryDocuments.length) {
            <li
              class="list-group-item list-group-item-warning text-center"
              [innerText]="translateLabel('ENQUIRIES.DOCUMENTS.EMPTY')"
            ></li>
          }
          @for (enquiryDocument of enquiryDocuments; track enquiryDocument.id; let i = $index) {
            <li class="list-group-item">
              <div class="row align-items-center">
                <div class="col-md-8">
                  <strong>{{ enquiryDocument.name }}</strong><br />
                  <small>
                    {{ enquiryDocument.document.type || 'n/a' }} -
                    {{ formatBytes(enquiryDocument.document.size) }}
                  </small>
                  <br />
                  <small>
                    {{ translateLabel('ENQUIRIES.DOCUMENTS.ADDED_ON') }}:
                    {{ enquiryDocument.created | date : 'dd/MM/yyyy HH:mm' }}
                  </small>
                  <br />
                  <small>
                    {{ translateLabel('ENQUIRIES.DOCUMENTS.ADDED_BY') }}:
                    {{
                    getUserFullname(usersObj[enquiryDocument.createdBy]) ||
                    translateLabel('GENERAL.UNKNOWN')
                    }}
                  </small>
                </div>
                <div class="col-md-4 text-md-end mt-2 mt-md-0">
                  @if (enquiryDocuments.length > 1) {
                    <button
                      type="button"
                      class="btn btn-primary btn-sm me-2"
                      (click)="moveEnquiryDocument(i, 'up')"
                      [disabled]="i === 0"
                      [title]="translateLabel('ENQUIRIES.DOCUMENTS.MOVE_UP')"
                      >
                      <fa-icon [icon]="faArrowUp"></fa-icon>
                    </button>
                  }
                  @if (enquiryDocuments.length > 1) {
                    <button
                      type="button"
                      class="btn btn-primary btn-sm me-2"
                      (click)="moveEnquiryDocument(i, 'down')"
                      [disabled]="i === enquiryDocuments.length - 1"
                      [title]="translateLabel('ENQUIRIES.DOCUMENTS.MOVE_DOWN')"
                      >
                      <fa-icon [icon]="faArrowDown"></fa-icon>
                    </button>
                  }
                  <button
                    type="button"
                    class="btn btn-secondary btn-sm me-2"
                    (click)="editEnquiryDocumentName(enquiryDocument)"
                    [title]="translateLabel('GENERAL.EDIT')"
                    >
                    <fa-icon [icon]="faEdit"></fa-icon>
                  </button>
                  @if (hasAclAccess(EnumAcl.enquiriesDownloadDocument)) {
                    <app-document-download-button collection="enquiryDocuments"
                      [documentId]="enquiryDocument.id" class="me-2"></app-document-download-button>
                  }
                  @if (hasAclAccess(EnumAcl.enquiriesDeleteDocument)) {
                    <button
                      type="button"
                      class="btn btn-danger btn-sm"
                      (click)="deleteEnquiryDocument(enquiryDocument.id)"
                      >
                      <fa-icon [icon]="faTrash"></fa-icon>
                    </button>
                  }
                </div>
              </div>
            </li>
          }
        </ul>
      </div>
    </div>
  }
</div>
<app-enquiry-confirmed-modal
  #enquiryConfirmedModal
  [enquiry]="enquiry"
  [lines]="lines"
  [quotations]="quotations"
  [fields]="fields"
  [legsList]="legsList"
  [airportsObj]="airportsObj"
  [defaultCurrency]="defaultCurrency"
  [isLogged]="isLogged"
  [initialSelectedCotationIds]="selectedConfirmedCotationsId"
  (saveConfirmed)="saveConfirmedCotations($event)"
></app-enquiry-confirmed-modal>
}

<app-enquiry-cancelled-modal
  #enquiryCancelledModal
  [reasonCancelled]="enquiry?.reasonCancelled || null"
  (saveCancelled)="saveStatusCancelled($event)"
></app-enquiry-cancelled-modal>
